export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 mb-3">投稿爆料</h2>
          <p className="text-sm text-foreground-600 mb-8 max-w-lg mx-auto">
            你有猛料？欢迎投稿！51黑料吃瓜网为每一位吃瓜群众开放爆料通道，你的线索可能成为今日黑料头条。
          </p>

          <div className="bg-background-50 border border-background-200/70 rounded-2xl p-8 md:p-10">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-xl text-primary-600 w-5 h-5 flex items-center justify-center"></i>
                </div>
                <h3 className="font-bold text-sm text-foreground-900 mb-1">邮件爆料</h3>
                <p className="text-xs text-foreground-500">tips@51heiliao.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-wechat-line text-xl text-accent-600 w-5 h-5 flex items-center justify-center"></i>
                </div>
                <h3 className="font-bold text-sm text-foreground-900 mb-1">微信投稿</h3>
                <p className="text-xs text-foreground-500">搜索: 51黑料吃瓜</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-chat-smile-2-line text-xl text-secondary-600 w-5 h-5 flex items-center justify-center"></i>
                </div>
                <h3 className="font-bold text-sm text-foreground-900 mb-1">在线提交</h3>
                <p className="text-xs text-foreground-500">7x24小时接收</p>
              </div>
            </div>

            <form className="space-y-4 text-left" data-readdy-form="true">
              <div className="contact-hp-field">
                <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-medium text-foreground-700 mb-1">你的昵称</label>
                  <input
                    type="text"
                    name="nickname"
                    placeholder="怎么称呼你？"
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-foreground-700 mb-1">电子邮箱</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="your@email.com"
                    className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                  />
                </div>
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-700 mb-1">爆料标题</label>
                <input
                  type="text"
                  name="title"
                  placeholder="简单描述你想爆料的内容..."
                  className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-700 mb-1">详细内容</label>
                <textarea
                  name="content"
                  rows={4}
                  maxLength={500}
                  placeholder="请详细描述你的爆料内容，包括时间、地点、人物等关键信息（限500字）..."
                  className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full py-3 rounded-full bg-primary-500 text-background-50 font-bold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                提交爆料
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}